import { render, staticRenderFns } from "./CardAccess.vue?vue&type=template&id=2a9a5c5f"
import script from "./CardAccess.vue?vue&type=script&lang=js"
export * from "./CardAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9a5c5f')) {
      api.createRecord('2a9a5c5f', component.options)
    } else {
      api.reload('2a9a5c5f', component.options)
    }
    module.hot.accept("./CardAccess.vue?vue&type=template&id=2a9a5c5f", function () {
      api.rerender('2a9a5c5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/CardAccess.vue"
export default component.exports